import { cn } from "./lib/utils"

function Skeleton({
  className,
  width,
  height,
  variant = 'text',
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  width?: string | number;
  height?: string | number;
  variant?: 'text' | 'rounded' | 'circular' | 'rectangle';
}) {
  const getSize = (size: string | number | undefined) => {
    if (typeof size === 'number') return `${size}px`;
    return size;
  };

  const variantClasses = {
    text: 'rounded',
    rounded: 'rounded-lg',
    circular: 'rounded-full',
    rectangle: 'rounded-none',
  };

  let defaultWidth = '100%';
  let defaultHeight = '1.2em';

  if (variant === 'circular') {
    defaultWidth = '2.5rem';
    defaultHeight = '2.5rem';
  } else if (variant === 'rounded' || variant === 'rectangle') {
    defaultWidth = '100%';
    defaultHeight = '1.25rem';
  }

  return (
    <div
      className={cn(
        'animate-pulse bg-muted',
        variantClasses[variant],
        className
      )}
      style={{
        width: getSize(width) || defaultWidth,
        height: getSize(height) || defaultHeight,
        display: variant === 'text' ? 'inline-block' : 'block',
        verticalAlign: variant === 'text' ? 'middle' : undefined,
      }}
      {...props}
    />
  );
}

export { Skeleton }
